export default __webpack_public_path__ + "static/media/ViewAnyRecordsIllustration.b1dbef39.svg";